﻿export * from './loandocument.component';
